import axios from "axios";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const pincodeAxios = axios.create();

export const fetchPincodeDetails = createAsyncThunk(
  "pincode/fetchPincodeDetails",
  async (pincode, { rejectWithValue }) => {
   // console.log(pincode)
    try {
      const response = await pincodeAxios.get(
        `https://api.postalpincode.in/pincode/${pincode}`
      );
      const data = response.data[0];

      if (data.Status === "Success") {
        return data.PostOffice;
      }
      return [];
    } catch (error) {
      console.error("Error fetching pincode details:", error);
      return rejectWithValue(error.message);
    }
  }
);

export const appPincodeSlice = createSlice({
  name: "pincode",
  initialState: {
    pincode: [],
    slugData: "",
    paginate: "",
    isloder: false,
    isdeleted: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPincodeDetails.pending, (state) => {
        state.isloder = true;
        state.error = null;
      })
      .addCase(fetchPincodeDetails.fulfilled, (state, action) => {
        state.pincode = action.payload;
        state.isloder = false;
      })
      .addCase(fetchPincodeDetails.rejected, (state, action) => {
        state.isloder = false;
        state.error = action.payload || "Failed to fetch pincode";
      });
  },
});

export default appPincodeSlice.reducer;
